export const concatenateStrings = (args: any[], separator: string, prefix?: string, suffix?: string): string => {
  args = args.filter(s => s).map(s => s.toString());
  if (suffix)  {
    args = args.map(s => s.concat(suffix));
  }

  if (prefix) {
    args = args.map(s => prefix.concat(s));
  }

  return args.join(separator);

}
